import { userConstants } from "../constants/login.constants";

 function individualElectronicLodgementService(state = {}, action) {
    switch (action.type) {
        case userConstants.INDIVIDUALELECTRONICLODGEMENTSERVICE_REQUEST:
            return {
                loading: true
            };
        case userConstants.INDIVIDUALELECTRONICLODGEMENTSERVICE_SUCCESS:
            return {
                items: action.individualElectronicLodgementService
            };
        case userConstants.INDIVIDUALELECTRONICLODGEMENTSERVICE_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default individualElectronicLodgementService;